import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CadastroService } from '../../../../../services/cadastro.service';
import { Cliente } from '../../../../../models/cadastro.model';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-clientes-manutencao',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, NgxMaskDirective],
  templateUrl: './clientes-manutencao.component.html',
  styleUrls: ['./clientes-manutencao.component.css']
})
export class ClientesManutencaoComponent implements OnInit {
  clienteForm: FormGroup;
  isEditMode = false;
  clienteId: number | null = null;
  ufs: string[] = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

  constructor(
    private fb: FormBuilder,
    private cadastroService: CadastroService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.clienteForm = this.fb.group({
      id: [0],
      nomeRazaoSocial: ['', Validators.required],
      nomeFantasia: [''],
      cpfCnpj: ['', Validators.required],
      endereco: [''],
      municipio: [''],
      uf: ['SP'],
      pais: [''],
      email: ['', Validators.email],
      telefone: ['', Validators.required],
      telefone2: [''],
      observacao: [''],
      restricaoAtiva: [false]
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.isEditMode = true;
        this.clienteId = +params['id'];
        this.cadastroService.getClienteById(this.clienteId).subscribe(cliente => {
          this.clienteForm.patchValue(cliente);
        });
      }
    });
  }

  salvarCliente(): void {
    if (this.clienteForm.invalid) {
      this.toastr.error('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    this.clienteForm.value.cpfCnpj = this.clienteForm.value.cpfCnpj.replace(/\D/g, '');
    this.clienteForm.value.telefone = this.clienteForm.value.telefone.replace(/\D/g, '');
    if (this.clienteForm.value.telefone2) {
      this.clienteForm.value.telefone2 = this.clienteForm.value.telefone2.replace(/\D/g, '');
    }
    const cliente: Cliente = this.clienteForm.value;

    if (this.isEditMode) {
      this.cadastroService.updateCliente(cliente).subscribe(() => {
        this.toastr.success('Cliente atualizado com sucesso!');
        this.router.navigate(['/home/cadastro-cliente']);
      },
      (error) => {
        this.toastr.error('Erro ao atualizar cliente.');
      });
    } else {
      this.cadastroService.createCliente(cliente).subscribe(() => {
        this.toastr.success('Cliente criado com sucesso!');
        this.router.navigate(['/home/cadastro-cliente']);
      },
      (error) => {
        this.toastr.error('Erro ao criar cliente.');
      });
    }
  }

  cancelar(): void {
    this.router.navigate(['/home/cadastro-cliente']);
  }
}
